import { Component, OnInit, ViewChild, inject } from '@angular/core';
import * as FileSaver from 'file-saver';
import { MovimentoArticoloModel } from 'src/app/models/movimento-articolo';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { FirmaObj } from 'src/app/models/firma-obj';
import { AlertService } from 'src/app/shared/services/alert.service';
import notify from 'devextreme/ui/notify';

import { ActivatedRoute } from '@angular/router';
import {
  DxButtonComponent,
  DxCheckBoxComponent,
  DxFileUploaderComponent,
  DxLoadIndicatorComponent,
  DxLoadPanelComponent,
  DxPopupComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import { StorageService } from 'src/app/shared/services/storage.service';
import { RUOLO_OPERATORE_BASE } from 'src/app/consts/const';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

declare let $: any;

@Component({
  selector: 'app-doc-movimento',
  templateUrl: './doc-movimento.component.html',
  styleUrls: ['./doc-movimento.component.scss'],
  imports: [
    NgxExtendedPdfViewerModule,
    DxButtonComponent,
    DxPopupComponent,
    DxFileUploaderComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent,
    DxLoadIndicatorComponent,
    DxCheckBoxComponent,
    DxButtonComponent,
    DxLoadPanelComponent
  ],
  standalone: true,
})
export class DocMovimentoComponent implements OnInit {
  @ViewChild('pdfViewer', { static: false }) pdfViewer!: any;

  private movS = inject(MovimentoArticoliService);
  private route = inject(ActivatedRoute);
  private navS = inject(NavigatorService);
  private alertS = inject(AlertService);
  private storageService = inject(StorageService);

  progrMov: number = 0;
  movimento: MovimentoArticoloModel = new MovimentoArticoloModel();
  restituito = '';
  showVisualizzaPDF = false;
  pdfSrc: any;
  zoomSlide = 100;
  divFirmaVisible = false;
  checkInviaMail = true;
  amWaiting = true;
  tempFirmaEseguita = false;
  uploadingFileFirmato = false;
  uploadingFileValue: any[] = [];
  consegnaGiornaliera?: boolean = undefined;

  isBase: boolean = false;
  popupWarning: boolean = false;
  loadPanelVisible = false;

  ngOnInit() {
    this.isBase =
      this.storageService.utenteCorrente.ruoloString == RUOLO_OPERATORE_BASE;
    this.route.paramMap.subscribe((params) => {
      const param = params.get('consegnaGiornaliera');
      this.consegnaGiornaliera =
        param == 'undefined' ? undefined : param == 'true';
    });
    this.loadData();
    (window as any).pdfWorkerSrc = '/assets/pdfViewer/pdfjs/pdf.worker.min.js';

    pdfDefaultOptions.assetsFolder = 'assets/pdfViewer';
  }

  loadData() {
    console.log('Ricarico dati');
    this.route.paramMap.subscribe((params) => {
      this.progrMov = +params.get('progrMov');
      this.movS.getByProgr(this.progrMov).subscribe({
        next: (dati) => {
          console.log('Ricarico dati 1');
          this.movimento = dati;
          if (!this.movimento.firmato && this.isBase) {
            this.popupWarning = true;
          }
          if (this.movimento.firmato) {
            this.movS.scaricaByProgr(this.progrMov).subscribe({
              next: (scarica) => {
                this.amWaiting = false;
                this.pdfSrc = scarica;
                this.showVisualizzaPDF = true;
              },
              error: (error) => {
                this.amWaiting = false;
                if (error?.status == 500 && error?.error?.title) {
                  notify(error?.error?.title, 'warning');
                } else {
                  notify('Errore download documento firmato', 'warning');
                }
              },
            });
          } else {
            this.movS
              .daFirmareByProgr(this.progrMov, this.consegnaGiornaliera)
              .subscribe({
                next: (scarica: Blob) => {
                  this.amWaiting = false;
                  this.pdfSrc = scarica;
                  // this.pdfViewer.refresh();
                  this.showVisualizzaPDF = true;
                },
                error: (error) => {
                  this.amWaiting = false;
                  if (error?.status == 500 && error?.error?.title) {
                    notify(error?.error?.title, 'warning');
                  } else {
                    notify('Errore download documento da firmare', 'warning');
                  }
                },
              });
          }
        },
        error: (error) => {
          this.amWaiting = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore caricamento dati movimento', 'warning');
          }
        },
      });
    });
  }

  scaricaPDF() {
    if (this.movimento.firmato) {
      FileSaver.saveAs(this.pdfSrc, this.movimento.allegato);
    } else {
      FileSaver.saveAs(this.pdfSrc, this.movimento.progr + '_temp.pdf');
    }
  }

  visualizzaPDF() {
    const url = window.URL.createObjectURL(this.pdfSrc);
    window.open(url, '_blank');
  }

  goToDashboardBase() {
    this.navS.goToDashboardGiornaliera();
  }

  goToMovimenti() {
    this.navS.goToTabMovimenti();
  }

  getZoomValue(): string {
    return 'page-width';
  }

  getStylePdf() {
    const zoomH = (1600 * this.zoomSlide) / 150;
    const zoomW = (1200 * this.zoomSlide) / 150;

    return {
      display: 'block',
      height: zoomH + 'px',
      width: zoomW + 'px',
    };
  }

  showFirmaDoc = () => {
    if (this.divFirmaVisible == false) {
      this.divFirmaVisible = true;
      setTimeout(() => {
        $('#signature').jSignature({
          lineWidth: 5,
          width: '100%',
          height: '100%',
        });
      }, 10);
    }
  };

  visualizzaPDFPerFirma() {
    this.amWaiting = true;
    this.movS
      .daFirmareCartaceaByProgr(this.progrMov, this.consegnaGiornaliera)
      .subscribe({
        next: (scarica) => {
          this.amWaiting = false;
          const url = window.URL.createObjectURL(scarica);
          window.open(url);
        },
        error: (error) => {
          this.amWaiting = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore visualizza pdf per firma', 'warning');
          }
        },
      });
  }

  okFirma = () => {
    if (this.divFirmaVisible == true) {
      this.divFirmaVisible = false;
    }
  };

  ripetiFirma = () => {
    $('#signature').jSignature('reset');
  };

  firmaMovimento = () => {
    const dataToBeSaved = $('#signature').jSignature('getData', 'image');
    const strFirma = dataToBeSaved[1];
    const firmaObj = new FirmaObj();
    firmaObj.firmaDati = strFirma;
    //firmaObj.inviaMail = this.checkInviaMail;
    this.divFirmaVisible = false;
    this.amWaiting = true;
    this.movS
      .firmaMovimento(this.movimento.progr, firmaObj, this.consegnaGiornaliera)
      .subscribe({
        next: (tempDocFirmato) => {
          this.amWaiting = false;
          this.pdfSrc = tempDocFirmato;
          this.showVisualizzaPDF = true;
          this.tempFirmaEseguita = true;
        },
        error: (error) => {
          this.amWaiting = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore firma documento', 'warning');
          }
        },
      });
  };

  preparaAllegaFileFirmato = () => {
    this.uploadingFileFirmato = true;
  };

  confermaFirma = () => {
    const inviaMail = this.checkInviaMail;
    const formData = new FormData();
    formData.append('file', this.pdfSrc);
    this.loadPanelVisible = true;
    this.movS
      .allegaFileFirmato(
        this.movimento.progr,
        inviaMail,
        formData,
        this.consegnaGiornaliera,
      )
      .subscribe({
        next: (res) => {
          this.loadPanelVisible = false;
          this.loadData();
          if (
            this.storageService.utenteCorrente.ruoloString !=
            RUOLO_OPERATORE_BASE
          ) {
            this.movS.updateCurrentListMovimentiArticoli();
            //Gestione alert
            this.alertS.sendClickEvent();
          }
        },
        error: (error) => {          
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore conferma firma', 'warning');
          }
        },
      });
  };

  allegaFileFirmato(e: any, files: any) {
    const result = e.validationGroup.validate();

    if (result.isValid) {
      this.loadPanelVisible = true;
      const inviaMail = this.checkInviaMail;
      const formData = new FormData();
      formData.append('file', files[0]);
      this.movS
        .allegaFileFirmato(
          this.movimento.progr,
          inviaMail,
          formData,
          this.consegnaGiornaliera,
        )
        .subscribe({
          next: () => {
            this.loadPanelVisible = false;
            this.uploadingFileFirmato = false;
            this.loadData();
            this.movS.updateCurrentListMovimentiArticoli();
          },
          error: (err) => {
            this.loadPanelVisible = false;
            if (err?.error?.title) {
              notificaMessaggio(err.error.title, 'warning');
            } else {
              notificaMessaggio('Errore allega file firmato', 'warning');
            }
            this.loadData();
          },
        });
    }
  }

  onFileUploaded(e: any) {
    const files = e.value;
    this.pdfSrc = window.URL.createObjectURL(files[0]);
  }
}
